import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TeamService } from "../../services/team.service";
import { ActivatedRoute } from "@angular/router";
import { TeamModel } from "../../models/team.model";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Meta, Title } from '@angular/platform-browser';
import { AppTitleService } from "../../services/title.service";
import { ProfileService } from "../../services/profile.service";
import { STORE_LINKS } from "../../constants/store-links";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss'
})
export class TeamComponent implements OnInit, OnDestroy {
  private _teamService: TeamService = inject(TeamService);
  private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private _ngxSmartModalService: NgxSmartModalService = inject(NgxSmartModalService);
  private _appTitleService: AppTitleService = inject(AppTitleService);
  private _meta: Meta = inject(Meta);
  private _profileService: ProfileService = inject(ProfileService);
  private _renderer: Renderer2 = inject(Renderer2);
  private _document: Document = inject(DOCUMENT);
  private _languageService: LanguageService = inject(LanguageService);

  team!: TeamModel;
  donateTo!: {public_id: number, name: string, type: 'team' | 'player'};
  pickupRequestCompleted: boolean = false;
  readonly storeLinks = STORE_LINKS;

  constructor() {}

  get currentLang(): string {
    return this._languageService.currentLang;
  }

  ngOnInit(): void {
    this.getTeam();
    this.setTheme();
  }

  setTheme(): void {
    this._meta.updateTag({ name: 'theme-color', content: '#2667ff' });
  }

  getTeam(): void {
    const teamId = this._activatedRoute.snapshot.params['id'];
    this._teamService.getTeam(teamId).subscribe(result => {
      this.team = result;
      this._profileService.setActiveProfile({ ...this.team, type: 'team' });
      if (this.team?.name) {
        this._appTitleService.setTitleFromKey('PAGE_TITLE.FORMAT_HP', { title: this.team.name });
      }
      this.updateSocialMeta(this.team?.banner);
    }, error => {
      console.error('er', error);
    });
  }

  private updateSocialMeta(imageUrl?: string | null): void {
    if (!imageUrl) {
      return;
    }
    const url = imageUrl;
    this._meta.updateTag({ property: 'og:image', content: url });
    this._meta.updateTag({ name: 'twitter:image', content: url });
  }

  openPickupRequestForm(team: boolean = false, player?: { public_id: number; first_name: string; last_name: string; avatar: string | null; }): void {
    this.donateTo = {
      public_id: player ? player.public_id : this.team.public_id,
      name: player ? `${player.first_name} ${player.last_name}` : this.team.name,
      type: team ? 'team' : 'player'
    }
    this._ngxSmartModalService.getModal('pickupRequestModal').open();
  }

  onPickupRequestSuccess(): void {
    this.pickupRequestCompleted = true;
  }

  ngOnDestroy(): void {
    this._profileService.setActiveProfile(null);
    this._meta.removeTag('name="theme-color"');
  }
}
